import { type StateCreator } from 'zustand';
import { PlanFlow } from '@energy-retailer/constants';
import { type StepsSliceActions } from './steps';
import { CheckboxSliceActions } from './checkbox';

export type FlowSliceActions = {
  resetFlow: () => void;
  setFlow: () => void;
};

export type FlowSliceState = {
  flow: PlanFlow;
};

export const initialState: FlowSliceState = {
  flow: PlanFlow.DualFuel,
};

export const FlowSlice: StateCreator<
  FlowSliceActions & FlowSliceState & CheckboxSliceActions & StepsSliceActions,
  [['zustand/devtools', never]],
  [],
  FlowSliceActions & FlowSliceState
> = (set, get) => ({
  ...initialState,
  setFlow: () => {
    const { gasChecked, electricityChecked } = get().getChecked();
    const steps = get().getSteps();
    let flow: PlanFlow;

    if (steps.length === 0) {
      return set(
        { flow: PlanFlow.NoSelection },
        undefined,
        'FlowSlice/setFlow'
      );
    }

    if ([gasChecked, electricityChecked].every(Boolean)) {
      flow = PlanFlow.DualFuel;
    } else {
      flow = gasChecked ? PlanFlow.Gas : PlanFlow.Electricity;
    }

    set({ flow }, undefined, 'FlowSlice/setFlow');
  },
  resetFlow: () => {
    set(initialState, undefined, 'FlowSlice/resetFlow');
  },
});
